module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Bself"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('div', {
    staticClass: "imgContent"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar,
      "alt": "头像"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "name": "avatar",
      "id": "avatar",
      "value": "上传头像",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadAvatar
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "avatar"
    }
  }, [_vm._v("上传头像")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "username"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("昵称：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showName),
      expression: "showName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.showName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.showName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("邮箱：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "shortInt"
  }, [_c('p', [_vm._v("个人简介：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shortInt),
      expression: "shortInt"
    }],
    attrs: {
      "name": "shortInt",
      "cols": "50",
      "rows": "6",
      "maxlength": "500",
      "placeholder": "请输入您的个人简介"
    },
    domProps: {
      "value": (_vm.shortInt)
    },
    on: {
      "change": _vm.updateShortInt,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shortInt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fontNum"
  }, [_vm._v("剩余可输入" + _vm._s(_vm.surplus) + "/500字")])]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('button', {
    on: {
      "click": _vm.updateSelfInfo
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72acb155"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/BAM/view/self.vue
// module id = 277
// module chunks = 1